const DUMMY_PROJECTS=[
    {
        projectTitle:'PortFolio Template',
        description: 'This project is a React app to generate a creative professional website based on Data provided. The website uses no backend and is free to fork and use.',
        sourceLink:'https://github.com/killer-abhi/Portfolio.git',
        lastUpdated:'Jan 20 2023'
    },
    {
        projectTitle:'Expense Tracker',
        description: 'A React project to get a track of weekly expenses. It also creates a graphical data to help monitor the expenses on daily basis',
        sourceLink:'https://github.com/killer-abhi/expense-tracker.git',
        lastUpdated:'Dec 30 2022'
    },
    {
        projectTitle:'Realtime Chat Site',
        description: 'It is a Realtime Chat Website built using Socket.io and Express with NodeJs as a backend and MongoDB as a database. It updates the chat messages in realtime with Typing notification of other users',
        sourceLink:'https://github.com/killer-abhi/realtime-chat-site.git',
        lastUpdated:'Dec 10 2022'
    },
    {
        projectTitle:'Food Order Website',
        description: 'It is a React based website demonstrating how food order works with Cart updates and storing it in Firebase Database.',
        sourceLink:'https://github.com/killer-abhi/food-order-react.git',
        lastUpdated:'Jan 25 2023'
    },
    {
        projectTitle:'Space Tourism Website',
        description: 'It is a solution to challenge of FrontEnd Mentors. It is a React website to depict facts about our Solar System. ',
        sourceLink:'https://github.com/killer-abhi/space-tour.git',
        lastUpdated:'Oct 16 2022'
    },
    {
        projectTitle:'Password Generator',
        description: 'A website where you can generate strong Passwords to use as Authentication in different websites and apps based on the difficulty level set by you. ',
        sourceLink:'https://github.com/killer-abhi/password-generator.git',
        lastUpdated:'Sep 24 2022'
    },
    {
        projectTitle:'QR Code Generator',
        description: 'A simple website to generate QR Code of any text provided as Input.It fetches an API to provide you the required QR Code.',
        sourceLink:'https://github.com/killer-abhi/qr-code-generator.git',
        lastUpdated:'Oct 24 2022'
    },
    {
        projectTitle:'Calculator',
        description: 'A Calculator to do basic operations. It is a React app with three different themes.',
        sourceLink:'https://github.com/killer-abhi/calculator.git',
        lastUpdated:'Sep 26 2022'
    },
];
const ProjectsData={DUMMY_PROJECTS};
export default ProjectsData;